import React from "react";
import { Button } from "../../components/tailwind/button/Button";

type SyncOptionsStepProps = {
  onBack: () => void;
  onSync: () => void;
  syncButtonTestId?: string;
  children?: React.ReactNode;
};

export const SyncOptionsStep: React.FC<SyncOptionsStepProps> = ({
  onBack,
  onSync,
  syncButtonTestId = "sync-btn",
  children,
}) => {
  return (
    <div className="tw-space-y-4">
      <button
        type="button"
        onClick={onBack}
        className="tw-flex tw-items-center tw-gap-1 tw-text-sm tw-text-gray-500 hover:tw-text-gray-700"
      >
        <i className="material-icons tw-text-base">arrow_back</i>
        Back
      </button>

      {children}

      <Button variant="primary" onClick={onSync} data-testid={syncButtonTestId}>
        Sync
      </Button>
    </div>
  );
};

type OverwriteExistingCheckboxProps = {
  checked: boolean;
  onChange: (checked: boolean) => void;
};

export const OverwriteExistingCheckbox: React.FC<OverwriteExistingCheckboxProps> = ({
  checked,
  onChange,
}) => {
  return (
    <label className="tw-flex tw-items-center tw-gap-2 tw-cursor-pointer">
      <input
        type="checkbox"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
        className="tw-rounded tw-border-gray-300 tw-text-blue-600 focus:tw-ring-blue-500"
      />
      <span className="tw-text-gray-700">Overwrite existing</span>
    </label>
  );
};
